import { environment } from 'app/config/environment';
import Dexie, { type Table } from 'dexie';
import type { IssueImageUpload } from './issueImages';
import type { Issue } from './issues';
import type { LocalePreference } from './locale';

class LocalDataDatabase extends Dexie {
  public issueImageUploads!: Table<IssueImageUpload, string>;
  public issues!: Table<Issue, string>;
  public locale!: Table<LocalePreference, number>;

  public constructor() {
    super(environment.LOCAL_PERSISTER_KEY);
    this.version(1).stores({
      issueImageUploads: 'id,issueId',
    });
    this.version(2).stores({
      issues: 'id,projectId',
    });
    this.version(3).stores({
      locale: 'id',
    });
  }
}

const db = new LocalDataDatabase();

export const clearLocalDatabase = async () => {
  const preserveTables = ['region'];
  const tablesToClear = db.tables.filter((table) => !preserveTables.includes(table.name));

  await Promise.all(tablesToClear.map((table) => table.clear()));
};

export default db;
